// Cycles product cards' extra photos over their featured image with a crossfade,
// one card at a time: a shared scheduler advances a single visible card per tick, in turn.
// Pauses when the tab is hidden, skips off-screen cards, and respects reduced motion.
const cards = new Set();
let timer = 0;
let turn = 0;
let interval = 2800;

function tick() {
  if (document.hidden) return;
  const ordered = [...cards]
    .filter((card) => card.visible)
    .sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));
  if (!ordered.length) return;
  turn %= ordered.length;
  ordered[turn].next();
  turn += 1;
}

function sync() {
  window.clearInterval(timer);
  timer = cards.size ? window.setInterval(tick, interval) : 0;
}

class CardImages extends HTMLElement {
  #index = 0;
  #observer = null;
  visible = false;

  connectedCallback() {
    this.layers = [...this.querySelectorAll('[data-card-image]')];
    if (!this.layers.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.#observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; });
    this.#observer.observe(this);
    interval = Number(this.dataset.interval) || interval;
    cards.add(this);
    sync();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    if (cards.delete(this)) sync();
  }

  next() {
    // 0 shows the featured image underneath; 1..n reveal each extra photo in turn.
    this.#index = (this.#index + 1) % (this.layers.length + 1);
    this.layers.forEach((layer, i) => {
      layer.classList.toggle('opacity-100', i + 1 === this.#index);
      layer.classList.toggle('opacity-0', i + 1 !== this.#index);
    });
  }
}

if (!customElements.get('s-card-images')) customElements.define('s-card-images', CardImages);
